import apis from 'auth/ApiInterceptor'

const AuthService = {
	login: async (email, password) => {
		return await apis({
			url: '/api/auth/author/login',
			method: 'post',
			data: {
				"username": email,
				"password": password,
				"client": "MOBILE"
			},
			header: {
				'Content-Type': 'application/json'
			}
		})
	},
	logout: async () => {
		return await apis({
			url: '/api/auth/logout',
			method: 'get',
		})
	},
	getUserProfile: async () => {
		return await apis({
			url: '/api/auth/getProfile',
			method: 'get',
		})
	}
}

export default AuthService